import type { LightSource } from "../interfaces";
import type { SimpleBoard } from "../levelgenerator/simpleBoard";
import { PhysicalThing } from "../physicalThing";
import { deserializeXY } from "../serialization";
import type { XY } from "../xy";
import { ZOrder } from "../zOrder";

export class Lamp extends PhysicalThing implements LightSource {
	static key = "Lamp";

	private innerRadius: number;
	private outerRadius: number;

	constructor(xy: XY, innerRadius: number = 1, outerRadius: number = 5) {
		super(xy, false);
		this.innerRadius = innerRadius;
		this.outerRadius = outerRadius;
	}

	isVisible(): boolean {
		return false;
	}

	getZOrder(): number {
		return ZOrder.AIR;
	}

	getLightInnerRadius(): number {
		return this.innerRadius;
	}

	getLightOuterRadius(): number {
		return this.outerRadius;
	}

	serialize(): Record<string, unknown> {
		return { ...super.serialize(), innerRadius: this.innerRadius, outerRadius: this.outerRadius };
	}

	static deserialize(data: any): Lamp {
		const l = new Lamp(
			deserializeXY(data.xy),
			typeof data.innerRadius === "number" ? data.innerRadius : 1,
			typeof data.outerRadius === "number" ? data.outerRadius : 5,
		);
		l.visualId = data.visualId;
		return l;
	}

	static override initOnBoard(xy: XY, board: SimpleBoard, props?: Record<string, unknown>): PhysicalThing[] {
		const inner = typeof props?.innerRadius === "number" ? (props.innerRadius as number) : 1;
		const outer = typeof props?.outerRadius === "number" ? (props.outerRadius as number) : 5;
		const lamp = new Lamp(xy, inner, outer);
		board.putThing(lamp);
		return [lamp];
	}
}
